export async function playAudioWithProcessing(
    track,
    result,
    eqNodesRef,
    audioCtxRef,
    params
) {
    const { left, right, sampleRate } = track;

    if (!left || left.length === 0) return;

    const audioCtx = audioCtxRef.current;
    if (!audioCtx) return;

    await audioCtx.resume();

    const buffer = audioCtx.createBuffer(2, left.length, sampleRate);
    buffer.copyToChannel(left, 0);
    buffer.copyToChannel(right, 1);

    const source = audioCtx.createBufferSource();
    source.buffer = buffer;

    const gainNode = audioCtx.createGain();
    gainNode.gain.value = result?.gain?.[0] ?? 1;

    const panNode = audioCtx.createStereoPanner();
    panNode.pan.value = result?.pan?.[0] ?? 0;

    // =========================
    // ✅ Band EQ（ここが本質）
    // =========================

    const createBandEQ = (low, high, gainDB) => {
        const center = (low + high) / 2;
        const width = Math.max(1, high - low);

        const node = audioCtx.createBiquadFilter();
        node.type = "peaking";

        node.frequency.value = center;

        // 🔥 Qが重要（帯域幅を再現）
        node.Q.value = center / width;

        node.gain.value = gainDB;

        return node;
    };

    const eqNodes = [];

    if (params?.EQ_UI) {
        const bass = params.EQ_UI.bass;
        const treble = params.EQ_UI.treble;

        eqNodes.push(
            createBandEQ(
                bass.lowcut,
                bass.highcut,
                bass.gain * 1 // スケール調整
            )
        );

        eqNodes.push(
            createBandEQ(
                treble.lowcut,
                treble.highcut,
                treble.gain * 1
            )
        );
    }

    // 保存（リアルタイム変更用）
    eqNodesRef.current.push(eqNodes);

    // =========================
    // 接続
    // =========================

    let prev = source;

    eqNodes.forEach((eq) => {
        prev.connect(eq);
        prev = eq;
    });

    prev.connect(gainNode);
    gainNode.connect(panNode);
    panNode.connect(audioCtx.destination);

    source.start();

    return source;
}